import { render, staticRenderFns } from "./tabService.vue?vue&type=template&id=53b0a9b9&"
import script from "./tabService.vue?vue&type=script&lang=js&"
export * from "./tabService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports